// extracted by mini-css-extract-plugin
export var alphaLight = ".4";
export var alphaUltraLight = ".1";
export var headerHeight = "50px";
export var titleColor = "rgba(50,20,170,.7)";
export var titleColorLight = "rgba(50,20,170,.4)";
export var titleColorUltraLight = "rgba(50,20,170,.1)";